// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__tXQQP","content":"style_content__P7jUR","footer":"style_footer__I7y6A"};